<template>
  <div>
    <div class="content-block"></div>
    <h2 class="content-block">Card Like</h2>

    <div class="content-block">
      <!-- Layout grid is configured here -->

      <div class="row">
        <table>
          <tr>
            <td>
              <div class="dx-card responsive-paddings">
                Put your content here2
                <div class="dx-field">
                  <div class="dx-field-label">Full Name</div>
                  <div class="dx-field-value-static">John Smith</div>
                </div>
              </div>
            </td>
            <td>
              <div class="dx-card responsive-paddings">
                Put your content here2
                <div class="dx-field">
                  <div class="dx-field-label">Full Name</div>
                  <div class="dx-field-value-static">John Smith</div>
                </div>
              </div>
            </td>
            <td>
              <div class="dx-card responsive-paddings">
                Put your content here2
                <div class="dx-field">
                  <div class="dx-field-label">Full Name</div>
                  <div class="dx-field-value-static">John Smith</div>
                </div>
              </div>
            </td>
            <td>
              <div class="dx-card responsive-paddings">
                Put your content here2
                <div class="dx-field">
                  <div class="dx-field-label">Full Name</div>
                  <div class="dx-field-value-static">John Smith</div>
                </div>
              </div>
            </td>
            <td>
              <div class="dx-card responsive-paddings">
                Put your content here2
                <div class="dx-field">
                  <div class="dx-field-label">Full Name</div>
                  <div class="dx-field-value-static">John Smith</div>
                </div>
              </div>
            </td>
            <td>
              <div class="dx-card responsive-paddings">
                Put your content here2
                <div class="dx-field">
                  <div class="dx-field-label">Full Name</div>
                  <div class="dx-field-value-static">John Smith</div>
                </div>
              </div>
            </td>
            <td>
              <div class="dx-card responsive-paddings">
                Put your content here2
                <div class="dx-field">
                  <div class="dx-field-label">Full Name</div>
                  <div class="dx-field-value-static">John Smith</div>
                </div>
              </div>
            </td>
            <td>
              <div class="dx-card responsive-paddings">
                Put your content here2
                <div class="dx-field">
                  <div class="dx-field-label">Full Name</div>
                  <div class="dx-field-value-static">John Smith</div>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <DxResponsiveBox>
        <DxRow :ratio="1"><DxCol>1</DxCol></DxRow>
        <DxRow :ratio="2" :shrink="2">2</DxRow>
        <DxRow :ratio="0.7">3</DxRow>
        <DxCol :ratio="0.5" :shrink="0.5">4</DxCol>
        <!-- The following columns appear on medium and large screens only -->
        <DxCol :ratio="2" screen="md lg">5</DxCol>
        <DxCol :ratio="0.5" screen="md lg">6</DxCol>
      </DxResponsiveBox>

      <div class="dx-card responsive-paddings">
        Put your content here
        <div class="marketing-demos">
          <h2>Sample Apps</h2>
          <p>
            Run one of&nbsp;sample apps in your browser or scan a QR code on
            your device to&nbsp;see DevExtreme in&nbsp;action.
          </p>
          <div class="demos-container">
            <div class="demo sales-viewer" data-type="web">
              <a href="/Demos/SalesViewer/" target="_blank">
                <div class="top">
                  <h4 class="demo-name">Sales Viewer</h4>
                  <p>
                    A&nbsp;data visualization web app simulating real-time data
                    analysis
                  </p>
                </div>
                <div class="center">
                  <img
                    src="https://js.devexpress.com/Demos/WidgetsGallery/Content/Images/Demos/salesviewer@2.png"
                    alt="Sales Viewer"
                  />
                </div>
              </a>

              <div class="widgets">
                <a class="widget" href="/Demos/WidgetsGallery/Demo/Charts/"
                  >Chart</a
                >
                <br />
                <a class="widget" href="/Demos/WidgetsGallery/Demo/DataGrid/"
                  >Data Grid</a
                >
                <br />
                <a
                  class="widget"
                  href="/Demos/WidgetsGallery/Demo/RangeSelector/"
                  >Range Selector</a
                >
                <br />
              </div>
            </div>
            <div class="demo devav" data-type="web">
              <a href="/Demos/DevAV/" target="_blank">
                <div class="top">
                  <h4 class="demo-name">DevAV</h4>
                  <p>A&nbsp;Microsoft Office inspired web application</p>
                </div>
                <div class="center">
                  <img
                    src="https://js.devexpress.com/Demos/WidgetsGallery/Content/Images/Demos/salesviewer@2.png"
                    alt="DevAV"
                  />
                </div>
              </a>

              <div class="widgets">
                <a class="widget" href="/Demos/WidgetsGallery/Demo/Charts/"
                  >Chart</a
                >
                <br />
                <a class="widget" href="/Demos/WidgetsGallery/Demo/DataGrid/"
                  >Data Grid</a
                >
                <br />
                <a class="widget" href="/Demos/WidgetsGallery/Demo/Form/"
                  >Form</a
                >
                <br />
              </div>
            </div>
            <div class="demo stock-market" data-type="web">
              <a href="/Demos/StockMarket/" target="_blank">
                <div class="top">
                  <h4 class="demo-name">Stock Market</h4>
                  <p>A&nbsp;stock market monitor and dashboard</p>
                </div>
                <div class="center">
                  <img
                    src="https://js.devexpress.com/Demos/WidgetsGallery/Content/Images/Demos/salesviewer@2.png"
                    alt="Stock Market"
                  />
                </div>
              </a>

              <div class="widgets">
                <a class="widget" href="/Demos/WidgetsGallery/Demo/Charts/"
                  >Chart</a
                >
                <br />
                <a class="widget" href="/Demos/WidgetsGallery/Demo/DataGrid/"
                  >Data Grid</a
                >
                <br />
                <a class="widget" href="/Demos/WidgetsGallery/Demo/PivotGrid/"
                  >Pivot Grid</a
                >
                <br />
              </div>
            </div>
            <div class="demo dx-election" data-type="web">
              <a
                href="https://devexpress.github.io/dx-election/"
                target="_blank"
              >
                <div class="top">
                  <h4 class="demo-name">DX Election</h4>
                  <p>
                    An&nbsp;Angular application designed to&nbsp;display results
                    from the US&nbsp;Presidential Election
                  </p>
                </div>
                <div class="center">
                  <img
                    src="https://js.devexpress.com/Demos/WidgetsGallery/Content/Images/Demos/salesviewer@2.png"
                    alt="DX Election"
                  />
                </div>
              </a>

              <div class="widgets">
                <a class="widget" href="/Demos/WidgetsGallery/Demo/Charts/"
                  >Chart</a
                >
                <br />
                <a class="widget" href="/Demos/WidgetsGallery/Demo/ScrollView/"
                  >Scroll View</a
                >
                <br />
                <a class="widget" href="/Demos/WidgetsGallery/Demo/VectorMap/"
                  >Vector Map</a
                >
                <br />
              </div>
            </div>
            <div class="demo golf-club" data-type="mobile">
              <a href="https://devexpress.github.io/golfclub/" target="_blank">
                <div class="top">
                  <h4 class="demo-name">Golf Club</h4>
                  <p>
                    A&nbsp;web application for booking golf course tee times
                  </p>
                  <div class="qr">
                    <img
                      src="https://api.qrserver.com/v1/create-qr-code/?size=85x85&amp;data=https%3a%2f%2fdevexpress.github.io%2fgolfclub%2f"
                      alt="Golf Club QR Code"
                      srcset="
                        https://api.qrserver.com/v1/create-qr-code/?size=170x170&amp;data=https%3a%2f%2fdevexpress.github.io%2fgolfclub%2f 2x
                      "
                    />
                  </div>
                </div>
                <div class="center">
                  <img
                    src="https://js.devexpress.com/Demos/WidgetsGallery/Content/Images/Demos/salesviewer@2.png"
                    alt="Golf Club"
                  />
                </div>
              </a>

              <div class="widgets">
                <a class="widget" href="/Demos/WidgetsGallery/Demo/DateBox/"
                  >Date Box</a
                >
                <br />
                <a class="widget" href="/Demos/WidgetsGallery/Demo/Form/"
                  >Form</a
                >
                <br />
                <a class="widget" href="/Demos/WidgetsGallery/Demo/Popup/"
                  >Popup</a
                >
                <br />
              </div>
            </div>
            <div class="demo sales-dashboard" data-type="mobile">
              <a
                href="/Demos/Simulator/?url=/Demos/SalesDashboard/&amp;deviceMode=Tablet"
                target="_blank"
              >
                <div class="top">
                  <h4 class="demo-name">Sales Dashboard</h4>
                  <p>
                    A&nbsp;data visualization web app optimized for touch
                    devices
                  </p>
                  <div class="qr">
                    <img
                      src="https://api.qrserver.com/v1/create-qr-code/?size=85x85&amp;data=http%3a%2f%2fjs.devexpress.com%2fDemos%2fSalesDashboard%2f"
                      alt="Sales Dashboard QR Code"
                      srcset="
                        https://api.qrserver.com/v1/create-qr-code/?size=170x170&amp;data=http%3a%2f%2fjs.devexpress.com%2fDemos%2fSalesDashboard%2f 2x
                      "
                    />
                  </div>
                </div>
                <div class="center">
                  <img
                    src="https://js.devexpress.com/Demos/WidgetsGallery/Content/Images/Demos/salesviewer@2.png"
                    alt="Sales Dashboard"
                  />
                </div>
              </a>

              <div class="widgets">
                <a class="widget" href="/Demos/WidgetsGallery/Demo/Charts/"
                  >Chart</a
                >
                <br />
                <a class="widget" href="/Demos/WidgetsGallery/Demo/DataGrid/"
                  >Data Grid</a
                >
                <br />
                <a
                  class="widget"
                  href="/Demos/WidgetsGallery/Demo/Gauges/ScaleCustomTickInterval/"
                  >Linear Gauge</a
                >
                <br />
              </div>
            </div>
            <div class="demo dxhotels" data-type="web">
              <a href="/Demos/DXHotels/" target="_blank">
                <div class="top">
                  <h4 class="demo-name">DXHotels</h4>
                  <p>A&nbsp;hotel booking web app</p>
                </div>
                <div class="center">
                  <img
                    src="https://js.devexpress.com/Demos/WidgetsGallery/Content/Images/Demos/salesviewer@2.png"
                    alt="DXHotels"
                  />
                </div>
              </a>

              <div class="widgets">
                <a class="widget" href="/Demos/WidgetsGallery/Demo/Accordion/"
                  >Accordion</a
                >
                <br />
                <a class="widget" href="/Demos/WidgetsGallery/Demo/DateBox/"
                  >Date Box</a
                >
                <br />
                <a class="widget" href="/Demos/WidgetsGallery/Demo/Form/"
                  >Form</a
                >
                <br />
              </div>
            </div>
            <div class="demo webserver-monitor" data-type="web">
              <a href="/Demos/WebServerMonitor/" target="_blank">
                <div class="top">
                  <h4 class="demo-name">WebServer Monitor</h4>
                  <p>A&nbsp;web app designed to&nbsp;monitor server health</p>
                </div>
                <div class="center">
                  <img
                    src="https://js.devexpress.com/Demos/WidgetsGallery/Content/Images/Demos/salesviewer@2.png"
                    alt="WebServer Monitor"
                  />
                </div>
              </a>

              <div class="widgets">
                <a class="widget" href="/Demos/WidgetsGallery/Demo/Charts/"
                  >Chart</a
                >
                <br />
                <a
                  class="widget"
                  href="/Demos/WidgetsGallery/Demo/RangeSelector/"
                  >Range Selector</a
                >
                <br />
              </div>
            </div>
            <div class="demo"></div>
            <div class="demo"></div>
            <div class="demo"></div>
            <div class="demo"></div>
            <div class="demo"></div>
            <div class="demo"></div>
            <div class="demo"></div>
            <div class="demo"></div>
            <div class="demo"></div>
            <div class="demo"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { DxResponsiveBox, DxCol, DxRow } from "devextreme-vue/responsive-box";
import { DxResponsiveBox, DxCol, DxRow } from "devextreme-vue/responsive-box";
export default {
  components: {
    DxResponsiveBox,

    DxCol,
    DxRow,
  },
};
</script>

<style>
html,
body {
  height: 100%;
}
.dx-field-label {
  float: right;
}
.dx-field-value {
  float: left;
}
.dx-field-value-static {
  float: left;
}
.index.view-content {
  padding: 0;
}
.index p {
  font-size: 14px;
  margin: 0;
  max-width: 1000px;
  line-height: 16px;
  color: #333;
}
.index h1 {
  font-size: 60px;
  line-height: 80px;
  color: #627789;
  margin: 0 0 30px;
}
.index h2 {
  font-size: 40px;
  margin: 0;
}
.index .title {
  padding: 20px 30px 25px;
}
.index .title > p {
  margin-bottom: 20px;
}
.index .title .block-content {
  display: block;
  display: flex;
  flex-wrap: wrap;
}
.index .title .block-content .content-item {
  display: inline-block;
  vertical-align: top;
  width: 275px;
  height: 90px;
  flex: 1 1 275px;
  margin: 0 10px 10px 0;
}
.index .title .block-content .content-item:empty {
  height: 0;
}
.index .title .block-content .content-item a {
  display: block;
  background: #f7f8f8;
  text-decoration: none;
  padding: 26px 0 26px 30px;
  height: 90px;
  box-sizing: border-box;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
}
.index .title .block-content .content-item a div {
  background-repeat: no-repeat;
  float: left;
  width: 40px;
  height: 40px;
}
.index .title .block-content .content-item a div rect,
.index .title .block-content .content-item a div path,
.index .title .block-content .content-item a div polygon,
.index .title .block-content .content-item a div circle {
  fill: #1b4461;
}
.index .title .block-content .content-item a h3 {
  font-size: 1.5em;
  line-height: 1.1em;
  color: #1b4461;
  margin: 5px 0 0 50px;
}
.index .title .block-content .content-item a h3.multi-line {
  margin-top: -8px;
}
.index .title .block-content .content-item a:hover {
  background: #f05b41;
}
.index .title .block-content .content-item a:hover div rect,
.index .title .block-content .content-item a:hover div path,
.index .title .block-content .content-item a:hover div polygon,
.index .title .block-content .content-item a:hover div circle {
  fill: white;
}
.index .title .block-content .content-item a:hover h3 {
  color: #fff;
}
.index .marketing-demos {
  padding: 40px 20px;
  background: #eef0f2;
}
.index .marketing-demos > p {
  margin-bottom: 25px;
}
.index .marketing-demos > p,
.index .marketing-demos h2 {
  padding-left: 10px;
}
.index .marketing-demos .demos-container {
  display: block;
  display: flex;
  flex-wrap: wrap;
}
.index .marketing-demos .demos-container .demo {
  margin: 0 10px 20px;
  vertical-align: top;
  display: inline-block;
  width: 400px;
  flex: 1 1 400px;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;
  position: relative;
}
.index .marketing-demos .demos-container .demo a {
  text-decoration: none;
}
.index .marketing-demos .demos-container .demo:empty {
  height: 0;
  margin-bottom: 0;
}
.index .marketing-demos .demos-container .demo:hover {
  box-shadow: 0 0 0 2px #f05b41;
}
.index .marketing-demos .demos-container .demo:hover .top {
  background-color: #f05b41;
}
.index .marketing-demos .demos-container .demo:hover .top .demo-name,
.index .marketing-demos .demos-container .demo:hover .top p {
  color: #fff;
}
.index .marketing-demos .demos-container .demo .top {
  background-color: #fff;
  padding: 15px 110px 22px 35px;
  position: relative;
}
.index .marketing-demos .demos-container .demo .top .demo-name {
  color: #1b4461;
  font-size: 28px;
  display: inline-block;
  vertical-align: top;
  margin: 0;
}
.index .marketing-demos .demos-container .demo .top p {
  height: 30px;
  color: #627789;
}
.index .marketing-demos .demos-container .demo .top .qr {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #fff;
  padding: 10px;
  height: 85px;
  z-index: 2;
}
.index .marketing-demos .demos-container .demo .top .qr img {
  width: 85px;
}
.index .marketing-demos .demos-container .demo .center {
  max-width: 600px;
}
.index .marketing-demos .demos-container .demo .center img {
  width: 100%;
  display: block;
}
.index .marketing-demos .demos-container .demo .widgets {
  position: absolute;
  width: 125px;
  right: 10px;
  bottom: 10px;
  text-align: right;
}
.index .marketing-demos .demos-container .demo .widgets .widget {
  background-color: #899eac;
  color: #fff;
  text-decoration: none;
  padding: 1px 10px 3px 10px;
  border-radius: 60px;
  white-space: nowrap;
  margin: 0 0 5px 7px;
  display: inline-block;
  font-size: 14px;
}
.index .marketing-demos .demos-container .demo .widgets .widget:hover {
  background-color: #f05b41;
  color: #fff;
}
.search-page > div {
  padding-top: 35px;
}
.search-page > div .search-message-image {
  margin: 1px 10px 0 0;
  display: inline-block;
  /* background-image: url("../Images/Layout/search-left-panel.svg"); */
  width: 38px;
  height: 48px;
}
.search-page > div .search-message {
  display: inline-block;
  color: #627789;
  vertical-align: top;
  font-size: 18px;
}
header.header .header-container,
.footer-container,
.body .body-container,
.tools-panel .tools-panel-content {
  max-width: 1940px;
  margin: 0 auto;
}
@media (max-width: 1270px) {
  body .view-content {
    margin-left: 0;
  }
  body:not(.hide-widgets-menu) .view-content.search-page {
    margin-left: 300px;
  }
  body.hide-widgets-menu .space-for-hide-menu {
    display: none;
  }
  body .widgets-menu-container {
    box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.15);
    -webkit-box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.15);
    -moz-box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.15);
  }
  body .space-for-hide-menu {
    display: block;
    width: 100%;
    height: 100%;
    z-index: 1;
    top: 0;
    left: 0;
    position: fixed;
  }
}
@media (max-width: 1025px) {
  .header,
  .tools-panel,
  .widgets-menu-container {
    position: absolute;
  }
  .body {
    position: static;
  }
  body:not(.hide-widgets-menu) .view-content.search-page {
    margin-left: 300px;
  }
}
@media (min-width: 1600px) {
  body.hide-widgets-menu .view-content:not(.wide-demo) .simulator-wrapper {
    width: 900px;
    float: left;
    padding-bottom: 40px;
  }
  body.hide-widgets-menu
    .view-content:not(.wide-demo)
    .simulator-wrapper.surveyjs {
    float: none;
    width: 100%;
  }
  body.hide-widgets-menu
    .view-content:not(.wide-demo)
    .simulator-wrapper.surveyjs
    .description-text {
    width: 900px;
    min-height: 600px;
  }
  body.hide-widgets-menu
    .view-content:not(.wide-demo)
    .simulator-wrapper.surveyjs
    .description-text
    .survey-details {
    position: absolute;
    top: 0;
    left: 935px;
    right: 0;
    margin-top: 0;
  }
  body.hide-widgets-menu .view-content:not(.wide-demo) .demo-details {
    min-width: auto;
    margin-left: 935px;
    padding-top: 86px;
    border-top: 2px solid #e9e9e9;
  }
}
@media (min-width: 1880px) {
  body .view-content:not(.wide-demo) .simulator-wrapper {
    width: 900px;
    float: left;
    padding-bottom: 40px;
  }
  body .view-content:not(.wide-demo) .simulator-wrapper.surveyjs {
    float: none;
    width: 100%;
  }
  body
    .view-content:not(.wide-demo)
    .simulator-wrapper.surveyjs
    .description-text {
    width: 900px;
    min-height: 600px;
  }
  body
    .view-content:not(.wide-demo)
    .simulator-wrapper.surveyjs
    .description-text
    .survey-details {
    position: absolute;
    top: 0;
    left: 935px;
    right: 0;
    margin-top: 0;
  }
  body .view-content:not(.wide-demo) .demo-details {
    min-width: auto;
    margin-left: 935px;
    padding-top: 86px;
    border-top: 2px solid #e9e9e9;
  }
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .view-content .code .buttons-container .buttons .fiddle.button.codepen {
    display: none;
  }
}
</style>
